/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TimeRange
 */
export interface TimeRange {
    /**
     * 
     * @type {Date}
     * @memberof TimeRange
     */
    startTime?: Date;
    /**
     * 
     * @type {Date}
     * @memberof TimeRange
     */
    endTime?: Date;
}

/**
 * Check if a given object implements the TimeRange interface.
 */
export function instanceOfTimeRange(value: object): value is TimeRange {
    return true;
}

export function TimeRangeFromJSON(json: any): TimeRange {
    return TimeRangeFromJSONTyped(json, false);
}

export function TimeRangeFromJSONTyped(json: any, ignoreDiscriminator: boolean): TimeRange {
    if (json == null) {
        return json;
    }
    return {
        
        'startTime': json['startTime'] == null ? undefined : (new Date(json['startTime'])),
        'endTime': json['endTime'] == null ? undefined : (new Date(json['endTime'])),
    };
}

export function TimeRangeToJSON(json: any): TimeRange {
    return TimeRangeToJSONTyped(json, false);
}

export function TimeRangeToJSONTyped(value?: TimeRange | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'startTime': value['startTime'] == null ? undefined : ((value['startTime']).toISOString()),
        'endTime': value['endTime'] == null ? undefined : ((value['endTime']).toISOString()),
    };
}

